// extracted by mini-css-extract-plugin
export var projectsCarousel__bottomBtn = "ProjectsFullWidthCarousel-module--projectsCarousel__bottom-btn--49c79";
export var projectsCarousel__header = "ProjectsFullWidthCarousel-module--projectsCarousel__header--5aecf";
export var projectsCarousel__headerLeft = "ProjectsFullWidthCarousel-module--projectsCarousel__headerLeft--4d715";
export var projectsCarousel__link = "ProjectsFullWidthCarousel-module--projectsCarousel__link--7105a";